import { backboneViewProperties } from "./../../decorators/backbone-properties";
import { MaterialFilterView } from "./material-filter";

@backboneViewProperties({
    childView: MaterialFilterView,
    className: "clearfix"
})
export class MaterialFilterGroupView extends Marionette.CollectionView<any, MaterialFilterView> {

}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/search/views/material-filter-group.ts